import styled from "styled-components";
import { IoLocationSharp } from "react-icons/io5";

const TYPE_STYLE = {
  "wu": {
    "1": {
      image: {
        transform: "scale(2.2)",
        transformOrigin: "36% 0%"
      },
      point: {
        top: "38%",
        left: "56.2%"
      }
    },
    "2": {
      image: {
        transform: "scale(2.2)",
        transformOrigin: "0% 12%"
      },
      point: {
        top: "39%",
        left: "34%"
      }
    },
    "3": {
      image: {
        transform: "scale(2.6)",
        transformOrigin: "90% 12%"
      },
      point: {
        top: "47.5%",
        left: "51%"
      }
    },
    "4": {
      image: {
        transform: "scale(1.4)",
        transformOrigin: "90% 10%"
      },
      point: {
        top: "81%",
        left: "84%"
      }
    },
    "5": {
      image: {
        transform: "scale(4.5)",
        transformOrigin: "81% 39%"
      },
      point: {
        top: "74%",
        left: "56.4%"
      }
    },
    "0": {
      image: {
        transform: "scale(4.5)",
        transformOrigin: "81% 39%"
      },
      point: {
        top: "71.6%",
        left: "48.4%"
      }
    }
  },
  "eumet": {
    "2": {
      image: {
        transform: "",
        transformOrigin: ""
      },
      point: {
        top: "50%",
        left: "50%"
      }
    },
    "3": {
      image: {
        transform: "",
        transformOrigin: ""
      },
      point: {
        top: "50%",
        left: "50%"
      }
    },
  },
  "ko": {
    "5": {
      image: {
        transform: "scale(1.4)",
        transformOrigin: "70% 40%"
      },
      point: {
        top: "70%",
        left: "62.4%"
      }
    },
    "0": {
      image: {
        transform: "scale(1.4)",
        transformOrigin: "70% 40%"
      },
      point: {
        top: "68%",
        left: "50.4%"
      }
    }
  }
} as {
  wu: {
    [id: string]: {
      image: React.CSSProperties,
      point: React.CSSProperties
    }
  },
  ko: {
    [id: string]: {
      image: React.CSSProperties,
      point: React.CSSProperties
    }
  }
  eumet: {
    [id: string]: {
      image: React.CSSProperties,
      point: React.CSSProperties
    }
  }
}

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  margin-top: 6px;
  position: relative;

  img {
    width: 100%;
    object-fit: cover;
    object-position: top;
    position: relative;
    top: 0;
  }
`;

const Point = styled.div`
  /* background-color: rgba(226, 50, 34, 1);
  outline: 5px solid rgba(113, 243, 245, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  z-index: 10;
  border-radius: 100%;
  transform: translateX(-50%) translateY(-50%); */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  transform: translateX(-50%) translateY(-100%);

  /* svg {
    font-size: 32px;
    color: rgba(226, 50, 34, 1);
  } */
  img {
    width: 30px;
  }
`;

const Image = styled.img<{hasFilter: boolean}>`
  ${props => props.hasFilter && ({
    filter: "brightness(200%)"
  })}
`;

interface SatImageProps {
  id: string;
  url: string;
  type: "ko" | "wu" | "eumet";
}

const SatImage = ({id, url, type}: SatImageProps) => {
  const idStyle = TYPE_STYLE[type];

  return <Container>
    <Image src={url} style={idStyle[id].image} hasFilter={type === "eumet"} />
    <Point style={idStyle[id].point}>
      <img src="/assets/location.png" />
    </Point>
  </Container>
}

export default SatImage;